import { render, staticRenderFns } from "./DialogTagEdit.vue?vue&type=template&id=bf5b3d02&"
import script from "./DialogTagEdit.vue?vue&type=script&lang=js&"
export * from "./DialogTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports